export default __webpack_public_path__ + "static/media/sort-down-alt.f5c506e8.svg";